import 'babel-polyfill'
import proj4 from "proj4";
import { register } from "ol/proj/proj4";
proj4.defs(
    "EPSG:28992",
    "+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +towgs84=565.417,50.3319,465.552,-0.398957,0.343988,-1.8774,4.0725 +units=m +no_defs"
);
proj4.defs("EPSG:4326", "+proj=longlat +datum=WGS84 +no_defs");

register(proj4);

import 'regenerator-runtime/runtime'
import Vue from 'vue'
import Map from './components/Map'
import dd from './sass/index.scss';
import Vuex from 'vuex'
import store from "./store/Store";
import { FETCH_CONFIG } from "./store/action-types";

Vue.use(Vuex)

store.commit('setIsPublicPage', true)
store.dispatch(FETCH_CONFIG);
var app = new Vue({
    el: '#app',
    store,
    render: (h) => h(Map)
})


